

























































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { electivePostponementModule } from "@/store/modules/ElectivePostponementStore";
import ElectivePostponementService from "@/services/ElectivePostponementService";

@Component
export default class ElectivePostponementForm extends Vue {
  @Prop({ default: null }) eventId!: number | null;
  @Prop({ default: () => [] }) reasonDefinitions!: any[];

  valid = true;
  saving = false;
  event: any = null;

  form: any = this.blankForm();

  jadwalDialog = false;
  jadwalLoading = false;
  jadwalCandidates: any[] = [];
  jadwalFilter: any = { tgl_from: "", tgl_to: "", search: "" };

  jadwalHeaders = [
    { text: "Jadwal", value: "t_jadwal" },
    { text: "No. RM", value: "no_rekam_medis" },
    { text: "Nama Pasien", value: "nama_pasien" },
    { text: "Operator", value: "dokter_operator_nama" },
    { text: "Rencana Tindakan", value: "jenis_tindakan" },
    { text: "", value: "aksi", sortable: false, align: "end" }
  ];

  previewed: any = null;

  tiers = [
    { key: "petugas", label: "Petugas Pengisi IBS" },
    { key: "ka_instalasi", label: "Kepala Instalasi IBS" },
    { key: "approver", label: "Komite Mutu / Direktur Medis" }
  ];

  get isEditing() {
    return !!this.eventId;
  }

  get shiftOptions() {
    return [
      { text: "Pagi (07-14)", value: "pagi" },
      { text: "Siang (14-21)", value: "siang" },
      { text: "Malam (21-07)", value: "malam" }
    ];
  }

  get unitOptions() {
    return [
      { text: "IBS", value: "ibs" },
      { text: "OK Central", value: "ok_central" },
      { text: "OK Elektif", value: "ok_elektif" },
      { text: "Poli Bedah", value: "poli_bedah" }
    ];
  }

  get jenisOperasiOptions() {
    return [
      { text: "Elektif", value: "elektif" },
      { text: "Emergensi", value: "emergensi" }
    ];
  }

  get eksklusiOptions() {
    return [
      { text: "Non-Elektif (emergensi)", value: "non_elektif" },
      { text: "Permintaan Pasien", value: "permintaan_pasien" },
      { text: "Force Majeure", value: "force_majeure" },
      { text: "Kondisi Klinis Prioritas", value: "kondisi_klinis_prioritas" }
    ];
  }

  get hasLainnyaSelected() {
    if (!this.form.reason_ids) return false;
    const lainnya = (this.reasonDefinitions || []).find((r: any) => r.kode === "ESP-LAINNYA");
    return lainnya ? this.form.reason_ids.includes(lainnya.id) : false;
  }

  get needsSectionE() {
    // Section E muncul jika preview menunjukkan tertunda, atau sudah ada status tertunda
    if (this.previewed && this.previewed.eksekusi === "tertunda") return true;
    if (this.event && this.event.eksekusi === "tertunda") return true;
    return false;
  }

  /**
   * Section D — daftar event lain di tanggal & unit yang sama.
   * Difilter dari store.events agar tidak perlu fetch ulang.
   */
  get rekapHarian() {
    const all = electivePostponementModule.events || [];
    const tgl = this.form.tanggal_operasi;
    const unit = this.form.unit_kamar_operasi;
    if (!tgl || !unit) return [];
    return all.filter((e: any) => {
      if (!e || !e.tanggal_operasi) return false;
      if (this.event && e.id === this.event.id) {
        // include current event also (rekap harian includes self)
        return e.tanggal_operasi === tgl && e.unit_kamar_operasi === unit;
      }
      return e.tanggal_operasi === tgl && e.unit_kamar_operasi === unit;
    });
  }

  /**
   * Section F — ringkasan capaian harian per unit.
   * Diambil dari store.dashboard.capaian_hari_ini (auto-fetch on mount/watch).
   */
  get capaianData() {
    const dash: any = electivePostponementModule.dashboard || {};
    const c = dash.capaian_hari_ini || {};
    return {
      numerator: c.numerator ?? 0,
      denominator: c.denominator ?? 0,
      capaian_persen: c.capaian_persen ?? 0,
      status_capaian: c.status_capaian ?? "-",
      target_persen: dash.target_persen ?? 5
    };
  }

  requiredRule(v: any) {
    return !!v || "Wajib diisi";
  }

  blankForm() {
    return {
      tanggal_operasi: localISODate(),
      shift: "pagi",
      unit_kamar_operasi: "ibs",
      nomor_kamar: "",
      nama_pengisi: this.$store.getters["user/user"]?.nama || "",
      nama_pengisi_id: this.$store.getters["user/user"]?.id || null,
      pasien_id: "",
      nama_pasien: "",
      no_rekam_medis: "",
      jenis_operasi: "elektif",
      dokter_operator_nama: "",
      dpjp_anestesi_nama: "",
      diagnosis_preop_icd10_kode: "",
      diagnosis_preop_icd10_uraian: "",
      jenis_tindakan: "",
      snomed_procedure_code: "",
      t_jadwal: "",
      t_aktual: "",
      timezone: "WIB",
      ambang_tunda_menit: 60,
      alasan_eksklusi: null,
      keterangan_eksklusi: "",
      reason_ids: [] as number[],
      alasan_lainnya_detail: "",
      rencana_tindak_lanjut: "",
      rtl_penanggung_jawab_nama: "",
      rtl_deadline: ""
    };
  }

  async mounted() {
    if (this.isEditing && this.eventId) {
      await this.loadEvent();
    }
    this.refreshDailyContext();
  }

  async loadEvent() {
    const data = await electivePostponementModule.fetchEvent(this.eventId as number);
    this.event = data;
    this.form = {
      tanggal_operasi: data.tanggal_operasi,
      shift: data.shift,
      unit_kamar_operasi: data.unit_kamar_operasi,
      nomor_kamar: data.nomor_kamar,
      nama_pengisi: data.nama_pengisi,
      nama_pengisi_id: data.nama_pengisi_id,
      pasien_id: data.pasien_id,
      nama_pasien: data.nama_pasien,
      no_rekam_medis: data.no_rekam_medis,
      jenis_operasi: data.jenis_operasi,
      dokter_operator_nama: data.dokter_operator_nama,
      dpjp_anestesi_nama: data.dpjp_anestesi_nama,
      diagnosis_preop_icd10_kode: data.diagnosis_preop_icd10_kode,
      diagnosis_preop_icd10_uraian: data.diagnosis_preop_icd10_uraian,
      jenis_tindakan: data.jenis_tindakan,
      snomed_procedure_code: data.snomed_procedure_code,
      t_jadwal: this.toLocalDateTime(data.t_jadwal),
      t_aktual: this.toLocalDateTime(data.t_aktual),
      timezone: data.timezone,
      ambang_tunda_menit: data.ambang_tunda_menit,
      alasan_eksklusi: data.alasan_eksklusi,
      keterangan_eksklusi: data.keterangan_eksklusi,
      reason_ids: (data.reasons || []).map((r: any) => r.id),
      alasan_lainnya_detail: data.alasan_lainnya_detail,
      rencana_tindak_lanjut: data.rencana_tindak_lanjut,
      rtl_penanggung_jawab_nama: data.rtl_penanggung_jawab_nama,
      rtl_deadline: data.rtl_deadline
    };
    this.previewStatus();
  }

  toLocalDateTime(v: string) {
    if (!v) return "";
    const d = new Date(v);
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  /**
   * Preview client-side status tanpa hit server.
   * Replikasi logika ElectivePostponementEvent::computeStatusFields().
   */
  previewStatus() {
    const ambang = Number(this.form.ambang_tunda_menit || 60);

    if (this.form.jenis_operasi !== "elektif") {
      this.previewed = {
        eksekusi: "eks",
        selisih_menit: null,
        keterangan: "Operasi non-elektif — dieksklusi dari INM."
      };
      return;
    }

    if (!this.form.t_jadwal) {
      this.previewed = null;
      return;
    }

    const tJ = new Date(this.form.t_jadwal).getTime();

    if (!this.form.t_aktual) {
      const now = Date.now();
      if (now > tJ + ambang * 60000) {
        this.previewed = {
          eksekusi: "tertunda",
          selisih_menit: Math.floor((now - tJ) / 60000),
          keterangan: "Belum dilaksanakan & sudah lewat ambang."
        };
      } else {
        this.previewed = {
          eksekusi: null,
          selisih_menit: null,
          keterangan: "Menunggu T-aktual (insisi pertama)."
        };
      }
      return;
    }

    const tA = new Date(this.form.t_aktual).getTime();
    const selisih = Math.floor((tA - tJ) / 60000);

    if (selisih < 0) {
      this.previewed = {
        eksekusi: "tidak",
        selisih_menit: selisih,
        keterangan: `Operasi dimajukan ${Math.abs(selisih)} menit.`
      };
    } else if (selisih <= ambang) {
      this.previewed = {
        eksekusi: "tidak",
        selisih_menit: selisih,
        keterangan: `Tepat waktu — ≤ ambang ${ambang} menit.`
      };
    } else {
      this.previewed = {
        eksekusi: "tertunda",
        selisih_menit: selisih,
        keterangan: `Tertunda ${selisih} menit (> ambang ${ambang} menit).`
      };
    }
  }

  async onSave() {
    const ref = this.$refs.form as any;
    if (!ref.validate()) return;

    // Pre-check Section E
    if (this.needsSectionE) {
      if (!this.form.reason_ids || this.form.reason_ids.length === 0) {
        alert("Alasan/kategori penundaan wajib dipilih minimal 1.");
        return;
      }
      if (!this.form.rencana_tindak_lanjut || this.form.rencana_tindak_lanjut.length < 20) {
        alert("Rencana Tindak Lanjut (RTL) wajib diisi minimal 20 karakter.");
        return;
      }
    }

    this.saving = true;
    try {
      if (this.isEditing) {
        await electivePostponementModule.updateEvent({
          id: this.eventId as number,
          data: this.form
        });
      } else {
        await electivePostponementModule.createEvent(this.form);
      }
      this.$emit("saved");
    } finally {
      this.saving = false;
    }
  }

  async onDelete() {
    if (!confirm("Yakin menghapus event ini?")) return;
    await electivePostponementModule.deleteEvent(this.eventId as number);
    this.$emit("saved");
  }

  canSign(tier: string) {
    if (!this.event || !this.event.signatures) return false;
    if (tier === "petugas") return !this.event.signatures.petugas.signed;
    if (tier === "ka_instalasi") {
      return this.event.signatures.petugas.signed && !this.event.signatures.ka_instalasi.signed;
    }
    if (tier === "approver") {
      return this.event.signatures.ka_instalasi.signed && !this.event.signatures.approver.signed;
    }
    return false;
  }

  async signTier(tier: string, label: string) {
    const nama = prompt(`Masukkan nama untuk tanda tangan — ${label}:`);
    if (!nama) return;
    await electivePostponementModule.signEvent({
      id: this.eventId as number,
      tier: tier as any,
      signedNama: nama
    });
    await this.loadEvent();
  }

  formatDateTime(v: string) {
    if (!v) return "-";
    return new Date(v).toLocaleString("id-ID");
  }

  formatTime(v: string) {
    if (!v) return "-";
    const d = new Date(v);
    if (isNaN(d.getTime())) return "-";
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  async refreshDailyContext() {
    if (!this.form.tanggal_operasi || !this.form.unit_kamar_operasi) return;
    try {
      await electivePostponementModule.fetchDashboard({
        tanggal: this.form.tanggal_operasi,
        unit_kamar_operasi: this.form.unit_kamar_operasi
      });
      // Ensure store.events populated (for rekapHarian)
      if (!electivePostponementModule.events || electivePostponementModule.events.length === 0) {
        const tgl = new Date(this.form.tanggal_operasi);
        await electivePostponementModule.fetchEvents({
          bulan: tgl.getMonth() + 1,
          tahun: tgl.getFullYear(),
          tanggal: "",
          unit_kamar_operasi: "",
          status: "",
          eksekusi: "",
          search: ""
        });
      }
    } catch (e) {
      // silent — D & F tetap tampil dengan default 0
    }
  }

  eksekusiColor(v: string) {
    if (v === "tertunda") return "red";
    if (v === "tidak") return "green";
    if (v === "eks") return "grey";
    return "blue-grey";
  }

  eksekusiLabel(v: string) {
    if (v === "tertunda") return "Tertunda";
    if (v === "tidak") return "Tepat Waktu";
    if (v === "eks") return "Eksklusi";
    return v || "-";
  }

  openJadwalDialog() {
    if (!this.jadwalFilter.tgl_from) {
      const now = new Date();
      const week = new Date(now.getTime() + 7 * 86400000);
      this.jadwalFilter.tgl_from = localISODate(now);
      this.jadwalFilter.tgl_to = localISODate(week);
    }
    this.jadwalDialog = true;
    this.loadJadwalCandidates();
  }

  async loadJadwalCandidates() {
    this.jadwalLoading = true;
    try {
      const res = await ElectivePostponementService.getScheduleCandidates({
        tgl_from: this.jadwalFilter.tgl_from,
        tgl_to: this.jadwalFilter.tgl_to,
        search: this.jadwalFilter.search || undefined
      });
      this.jadwalCandidates = res.data.data || [];
    } catch (e) {
      this.jadwalCandidates = [];
    } finally {
      this.jadwalLoading = false;
    }
  }

  applyJadwal(row: any) {
    const isi: any = {
      tanggal_operasi: row.tanggal_operasi,
      shift: row.shift,
      t_jadwal: row.t_jadwal,
      pasien_id: row.pasien_id,
      no_rekam_medis: row.no_rekam_medis,
      nama_pasien: row.nama_pasien,
      dokter_operator_id: row.dokter_operator_id,
      dokter_operator_nama: row.dokter_operator_nama,
      diagnosis_preop_icd10_kode: row.diagnosis_preop_icd10_kode,
      diagnosis_preop_icd10_uraian: row.diagnosis_preop_icd10_uraian,
      jenis_tindakan: row.jenis_tindakan,
      jenis_operasi: "elektif"
    };
    Object.keys(isi).forEach(k => {
      if (isi[k] !== null && isi[k] !== undefined && isi[k] !== "") {
        this.$set(this.form, k, isi[k]);
      }
    });
    this.jadwalDialog = false;
    this.previewStatus();
    this.refreshDailyContext();
  }

  formatJadwal(v: string) {
    if (!v) return "-";
    return v.replace("T", " ");
  }

  @Watch("form.jenis_operasi")
  onJenisOperasiChange() {
    this.previewStatus();
  }

  @Watch("form.alasan_eksklusi")
  onEksklusiChange(v: string | null) {
    if (!v) this.form.keterangan_eksklusi = "";
    this.previewStatus();
  }

  @Watch("form.tanggal_operasi")
  onTanggalChange() {
    this.refreshDailyContext();
  }

  @Watch("form.unit_kamar_operasi")
  onUnitChange() {
    this.refreshDailyContext();
  }
}
